import React, { useState } from 'react';

import Spinner from '../compUtils/Spinner';
import Icon from '../compUtils/Icon';



function RegisterPage(props) {

  const [profilePict, setProfilePict] = useState("")

/*
  function showMyImage(fileInput) {
    var file = fileInput.value;

    var reader = new FileReader();
    reader.onload = (function (aImg) {
      return function (e) {
        profilePict = e.target.result;
      };
    })(img);
    reader.readAsDataURL(file);

  }


  onchange={showMyImage(this)}
*/
  return (

    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container">

          <div class="columns is-centered">
            <div class="column is-5-tablet is-4-desktop is-3-widescreen">
              <div  class="box">
                <div class="field">
                  <label  class="label">Nom</label>
                  <div class="control has-icons-left">
                    <input type="text" placeholder="e.g. Romain" class="input" required />
                    <span class="icon is-small is-left">
                      <Icon name="head-side" />
                    </span>
                  </div>
                </div>

                <div class="field">
                  <label  class="label">Photo de profil</label>
                  <div class="control has-icons-left">

                    <a class="button button is-dark is-fullwidth is-medium">
                      <span class="icon is-small">
                        <Icon name="upload" />
                      </span>
                      <span>Upload image</span>
                      <input type="file" accept="image/jpeg"  value=""
                        class="button button is-dark chooseFile" />
                    </a>

                  </div>
                  <figure class="image is-128x128">
                    {profilePict !== "" ?
                      <img class="is-rounded" src={profilePict} alt="" />
                      :
                      <Spinner />
                    }

                  </figure>
                </div>

                <div class="field">
                  <label  class="label">Email (sera le login)</label>
                  <div class="control has-icons-left">
                    <input type="email" placeholder="e.g. bobsmith@gmail.com" class="input" required />
                    <span class="icon is-small is-left">
                      <Icon name="envelope" />
                    </span>
                  </div>
                </div>
                <div class="field">
                  <label  class="label">Password</label>
                  <div class="control has-icons-left">
                    <input type="password" placeholder="*******" class="input" required />
                    <span class="icon is-small is-left">
                      <Icon name="lock" />
                    </span>
                  </div>
                </div>
                <div class="field">
                  <label class="label">Password confirmation</label>
                  <div class="control has-icons-left">
                    <input type="password" placeholder="*******" class="input" required />
                    <span class="icon is-small is-left">
                      <Icon name="lock" />
                    </span>
                  </div>
                </div>
                <div class="field">
                  <button class="button is-success">
                    Register
              </button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

  );
}

export default RegisterPage;
